<template>
  <div class="container-pag">
    <div class="w-100 text-center">

      <!-- STEP 1: NOME + TECLADO -->
      <div v-if="step === 1">
        <!-- campo visual -->
        <div class="nome-box mb-4">
          {{ dados.nome || 'Digite seu nome...' }}
        </div>

        <!-- teclado -->
        <div class="keyboard">
          <div class="kb-row" v-for="(row, i) in keyboard" :key="i">
            <button class="kb-key" v-for="key in row" :key="key" @click="digitar(key)">
              {{ key }}
            </button>
          </div>

          <div class="kb-row">
            <button class="kb-key back" @click="apagar">←</button>
            <button class="kb-key space" @click="digitar(' ')">Espaço</button>
            <button class="kb-key ok" @click="confirmarNome" :disabled="!dados.nome">
              OK
            </button>
          </div>
        </div>
      </div>

      <!-- STEP 2: PAGAMENTO -->
      <div class="mt-4" v-if="step === 2">
        <h5 class="mb-4">Como gostaria de pagar seu pedido?</h5>
        <div class="row justify-content-center">
          <div class="col-4" v-for="p in pagamentos" :key="p.id_pagamento">
            <div class="card pointer" @click="selPagamento(p.id_pagamento)">
              <div class="card-body py-5">
                <img :src="p.img" :alt="p.nome_pagamento" style="width: 48px">
                <div class="mt-2">{{ p.nome_pagamento }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "PagamentoTablet",

  data() {
    return {
      step: 1,
      dados: { nome: '', id_pagamento: null },

      pagamentos: [
        { id_pagamento: '28', nome_pagamento: 'Pix', img: 'https://lecard-cdn.nyc3.digitaloceanspaces.com/lecard-corporativo/static/brands/pix.png' },
        { id_pagamento: '4', nome_pagamento: 'Débito', img: 'https://lecard-cdn.nyc3.digitaloceanspaces.com/lecard-corporativo/static/brands/cartaodedebito.png' },
        { id_pagamento: '3', nome_pagamento: 'Crédito', img: 'https://lecard-cdn.nyc3.digitaloceanspaces.com/lecard-corporativo/static/brands/cartaodecredito.png' }
      ],

      keyboard: [
        ['Q','W','E','R','T','Y','U','I','O','P'],
        ['A','S','D','F','G','H','J','K','L'],
        ['Z','X','C','V','B','N','M']
      ]
    }
  },

  methods: {
    selPagamento(pag) {
      this.dados.id_pagamento = pag;
      this.$emit('selDados', this.dados)
    },

    digitar(letra) {
      if (this.dados.nome.length >= 30) return
      this.dados.nome += letra
    },

    apagar() {
      this.dados.nome = this.dados.nome.slice(0, -1)
    },

    confirmarNome() {
      this.step = 2
    }
  }
}
</script>
<style scoped>
.container-pag {
  display: flex;
  align-items: center;
  justify-content: center;
}

.nome-box {
  width: min(500px, 100%);
  margin: 0 auto;
  height: clamp(52px, 7vw, 64px);
  border: 2px solid #ddd;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: clamp(16px, 3.2vw, 20px);
  font-weight: bold;
  background: #fafafa;
  padding: 0 12px;
  text-align: center;
}

.keyboard {
  width: min(520px, 100%);
  margin: 0 auto;
  padding: clamp(8px, 2vw, 12px);
}

.kb-row {
  display: flex;
  justify-content: center;
  gap: clamp(6px, 1.2vw, 10px);
  margin-bottom: clamp(8px, 1.6vw, 12px);
}

/* Teclas */
.kb-key {
  flex: 1 1 0;
  min-width: 32px;
  height: 48px;                /* altura fixa */
  font-size: 16px;
  border-radius: 10px;
  border: 1px solid #f1f1f1;
  background: #fff;
  font-weight: bold;
  padding: 0;
  touch-action: manipulation;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

/* Linha de ações */
.kb-row:last-child .back {
  flex: 1 1 0;
}

.kb-row:last-child .space {
  flex: 2.4 1 0;
}

.kb-row:last-child .ok {
  flex: 1 1 0;
}

.kb-key:active {
  background: #ddd;
}

.ok {
  background: var(--lecard-primary);
  color: white;
  border-color: transparent;
}

/* Ajuste telas muito pequenas */
@media (max-width: 360px) {
  .keyboard { padding: 8px; }
  .kb-row { gap: 6px; }
}
</style>